var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFailedPayment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 262,
    viewBox: "0 0 203 262",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 136,
    height: 260,
    rx: 11,
    stroke: "#212429",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 44,
    width: 108,
    height: 22,
    rx: 4,
    fill: "#DEE1E6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 75,
    width: 85,
    height: 42,
    rx: 4,
    fill: "#E9EDF0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 128,
    width: 85,
    height: 42,
    rx: 4,
    fill: "#CFD4DA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 179,
    width: 108,
    height: 42,
    rx: 4,
    fill: "#F2F3F7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 81,
    width: 156,
    height: 98,
    rx: 4,
    fill: "#3681D3"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 130,
    width: 4,
    height: 10,
    rx: 0.5,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 149,
    width: 5,
    height: 10,
    rx: 0.5,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 149,
    width: 5,
    height: 10,
    rx: 0.5,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 149,
    width: 5,
    height: 10,
    rx: 0.5,
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 149,
    width: 5,
    height: 10,
    rx: 0.5,
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 107,
    width: 24,
    height: 5,
    rx: 0.5,
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 98,
    width: 24,
    height: 5,
    rx: 0.5,
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 98,
    width: 24,
    height: 5,
    rx: 0.5,
    fill: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 130,
    width: 4,
    height: 10,
    rx: 0.5,
    fill: "white"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 130,
    width: 4,
    height: 10,
    rx: 0.5,
    fill: "white"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 130,
    width: 4,
    height: 10,
    rx: 0.5,
    fill: "white"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 130,
    width: 4,
    height: 10,
    rx: 0.5,
    fill: "white"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 130,
    width: 4,
    height: 10,
    rx: 0.5,
    fill: "white"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 130,
    width: 4,
    height: 10,
    rx: 0.5,
    fill: "white"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 130,
    width: 4,
    height: 10,
    rx: 0.5,
    fill: "white"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 130,
    width: 4,
    height: 10,
    rx: 0.5,
    fill: "white"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 130,
    width: 4,
    height: 10,
    rx: 0.5,
    fill: "white"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 130,
    width: 4,
    height: 10,
    rx: 0.5,
    fill: "white"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 130,
    width: 4,
    height: 10,
    rx: 0.5,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 159,
    cy: 84,
    r: 29,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M159.665 47C139.463 47 123 63.4626 123 83.665C123 103.867 139.463 120.33 159.665 120.33C179.867 120.33 196.33 103.867 196.33 83.665C196.33 63.4626 179.867 47 159.665 47ZM171.984 92.0979C173.048 93.1612 173.048 94.9212 171.984 95.9844C171.434 96.5344 170.738 96.7911 170.041 96.7911C169.345 96.7911 168.648 96.5344 168.098 95.9844L159.665 87.5515L151.232 95.9844C150.682 96.5344 149.985 96.7911 149.289 96.7911C148.592 96.7911 147.896 96.5344 147.346 95.9844C146.282 94.9212 146.282 93.1612 147.346 92.0979L155.779 83.665L147.346 75.232C146.282 74.1688 146.282 72.4088 147.346 71.3456C148.409 70.2823 150.169 70.2823 151.232 71.3456L159.665 79.7785L168.098 71.3456C169.161 70.2823 170.921 70.2823 171.984 71.3456C173.048 72.4088 173.048 74.1688 171.984 75.232L163.551 83.665L171.984 92.0979Z",
    fill: "#FA5252"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedPayment);
export default __webpack_public_path__ + "static/media/failed-payment.cf9e2e41b71bb6d98ddbad8f2d27cb81.svg";
export { ForwardRef as ReactComponent };